import type { MayBe } from 'modules/global/typing/common/common';

type NavigateOptions = {
  replace?: boolean;
  state?: unknown;
};

type Navigable = {
  navigate: (path: string, options?: NavigateOptions) => unknown;
};

let routerInstance: MayBe<Navigable>;

export const registerRouter = (router: Navigable): void => {
  routerInstance = router;
};

export const navigate = (path: string, options: NavigateOptions = {}): void => {
  if (!routerInstance) {
    throw new Error('navigate() called before registerRouter() — call it during app bootstrap.');
  }

  routerInstance.navigate(path, options);
};
